// extracted by mini-css-extract-plugin
export default {"testSearch":"KaGSuAocs8AC4qc3NTAg3","text-map":"_1VCXGhixBzpkR55UdZLJOp","col-lg-8":"_3awizNNvb4woGYlPANtoeh","col-lg-4":"_3LiOCk_FJccgkbFbCpGFIj","button":"_2qvUFnpHe5m7RiK0U_h0sO"};